import { Directive, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { startWith, switchMap } from 'rxjs/operators';

import { OrganisationPermissionType } from '@assetaccountant/api/models/organisation-permission-type';
import { AuthorizationService } from '../services/authorization.service';
import { Authorizer } from './authorizer';
import { getRouteChangesWith } from './authorizer.helpers';

@Directive()
export abstract class AuthorizeOrganisationBase implements Authorizer, OnChanges {
  private input$ = new BehaviorSubject<null>(null);
  readonly order = 10;

  readonly changes$ = getRouteChangesWith(
    this.router,
    'organisation',
    ({ activeOrganisation: organisation }) => ({ organisationId: organisation.organisationId }),
    this.input$,
  );

  readonly isAuthorizedChanges = this.changes$.pipe(
    switchMap(data => {
      if (data) {
        return this.isAuthorizedForOrganisation(data.organisationId).pipe(startWith(false));
      }
      return of(false);
    }),
  );

  constructor(
    private authorizationService: AuthorizationService,
    private router: Router,
  ) {}

  ngOnChanges() {
    this.input$.next(null);
  }

  protected abstract isAuthorizedForOrganisation(organisationId: number): Observable<boolean>;

  protected isAuthorizedForPermission(
    organisationId: number,
    permission: OrganisationPermissionType,
  ) {
    return this.authorizationService.isOrganisationAuthorized(organisationId, permission);
  }
}
